import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AuthAPI, { CDN_URL } from '../AuthAPI';
import { useValidator } from '@arema/components/Hooks';
import { Button, Icon, Input, Message } from 'react-frontier';
import { Link, useLocation } from 'react-router-dom';
import { SetLoading } from '@arema/components/Classes';
import { useAuth } from '../AuthHooks';

var ForgotPassword = ()=>{
	var { t } = useTranslation();
	var { getCaptcha, params } = useAuth();
	var { search } = useLocation();
	var [sent, setSent] = useState<boolean>(false);
	var form = useValidator({
		email: ''
	}, {
		email: [{ rule: 'email', prompt: t('login.prompts.email') }]
	});

	var sendForgot = async (setLoading: SetLoading)=>{
		var { valid } = form.validate();
		if(!valid) return;

		setLoading(true);
		try{
			var captcha = await getCaptcha();
			if(!captcha) return form.setPrompts([t('common.captcha_error')]);
		}catch(e){
			setLoading(false);
			return form.setPrompts([t('common.unexpected_code', { code: 'LCL-ATHFR-1' })]);
		}
		
		try{
			var res = await AuthAPI.sendForgot(form.data.email, params.source, captcha);
			if(res.error) return form.setPrompts([res.message]);
			setSent(true);
		}catch(e){
			return form.setPrompts([t('common.unexpected_code', { code: 'LCL-ATHFR-2' })]);
		}finally{
			setLoading(false);
		}
	}
	
	return <div className="ar login-screen">
		<div className="contents">
			<img className='ar logo' src={`${CDN_URL}/logo/LogoH_Large.webp`} alt="AREMA" />
			{sent ? (
				<div className="complete">
					<Icon name='envelope' />
					<div className="title">
						{t('forgot.sent_title')}
					</div>
					<div className="subtitle">
						{t('forgot.sent_subtitle')}
					</div>
					<Button color='black' text={t('common.login')} as={Link} to={`/${search}`} style={{ marginTop: 10 }} />
				</div>
			) : <>
				<div className="title">
					{t('forgot.title')}
				</div>
				<div className="subtitle">
					{t('forgot.subtitle')}
				</div>
				<div className="form">
					<Message centered type='info' text={t('forgot.instructions')} style={{ marginBottom: 15 }} />
					<Input label={t('common.email')} error={form.errors.email} value={form.data.email} onChange={form.onDataChange('email')} />

					<Message type='error' list={form.prompts} style={{ marginBottom: 15 }} />
					<div className="actions">
						<Button basic text={t('common.return')} as={Link} to={`/${search}`} />
						<Button color='black' text={t('common.send')} onClick={sendForgot} />
					</div>
				</div>
			</>}
		</div>	
	</div>
}

export default ForgotPassword;